<template>
    <div id="div_footer">
        <p>
            Junpeng Wang | Last updated: Mar. 2025
        </p>
    </div>
</template>

<script>
export default {}
</script>

<style scoped>

#div_footer { 
    content: " "; 
    display: block;
    clear: both;
    border-top: 1px solid #eeeeee;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    font-size: 12.5px;
} 



</style>



// WEBPACK FOOTER //
// src/components/footer.vue